import React from 'react';
import grantPermission from '../helpers/grantPermission';

function AuthenticatedContent({ children, role }) {
  return (
    <>
      {grantPermission(role) && children}
    </>
  );
}

export default AuthenticatedContent;